module.exports = __webpack_public_path__ + "static/img/tu3.1f2ca299.png";